import { render, staticRenderFns } from "./Viewer.vue?vue&type=template&id=ffb2dca6"
import script from "./Viewer.vue?vue&type=script&lang=js"
export * from "./Viewer.vue?vue&type=script&lang=js"
import style0 from "@/assets/sass/pages/_report-viewer.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./Viewer.vue?vue&type=style&index=1&id=ffb2dca6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports